import { useEffect, useState } from 'react';
import { createFilterOptions } from '@mui/material';

import { Autocomplete, Chip, List } from '@atom/mui';
import colors from '@atom/styles/colors';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

const { ListItemText } = List;

const styles = {
  chip: {
    marginBottom: '5px',
    marginRight: '5px',
    backgroundColor: colors.neutral.ash,
    borderRadius: '20px',
  },
};

const filterOptions = createFilterOptions<string>({
  matchFrom: 'any',
  limit: 250,
});

interface Props {
  id: string;
  value: any;
  onChange: (value: any) => void;
  options?: string[];
  disabled?: boolean;
  error?: boolean;
  dataCyPrefix?: string;
  placeholder?: string;
  label?: string;
}

const EnumMultipleInput = ({
  id,
  value = [],
  onChange,
  options = [],
  disabled = false,
  error = false,
  dataCyPrefix = '',
  placeholder = '',
  label = '',
}: Props) => {
  const [values, setValues] = useState<string[]>([]);
  const [query, setQuery] = useState<string>('');

  const handleChange = (newValues: string[]) => {
    setValues(newValues);
    onChange(newValues);
  };

  const handleDeselect = (newValue: string) => {
    if (disabled) {
      return;
    }

    const newValues = values.filter(option => option !== newValue);
    setValues(newValues);
    onChange(newValues);
  };

  useEffect(() => {
    if (!isNilOrEmpty(value)) {
      setValues(value || []);
      setQuery('');
    }
  }, [value]);

  return (
    <Autocomplete
      id={id}
      multiple
      fullWidth
      options={options}
      disabled={disabled}
      inputValue={query}
      error={error}
      label={label}
      placeholder={placeholder}
      filterOptions={filterOptions}
      onInputChange={(event, newQuery) => setQuery(newQuery || '')}
      getOptionLabel={item => item}
      value={values}
      disableCloseOnSelect
      onChange={(event, newValues) => {
        handleChange(newValues);
      }}
      renderOption={(optionProps, item) => (
        <li key={item} {...optionProps}>
          <ListItemText primary={item} />
        </li>
      )}
      renderValue={selected => {
        return selected.map(item => (
          <Chip
            key={item}
            style={styles.chip}
            label={item}
            onDelete={() => handleDeselect(item)}
          />
        ));
      }}
      data-cy={dataCyPrefix}
    />
  );
};

export default EnumMultipleInput;
